import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { AdminAuthProvider } from "@/context/AdminAuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import ProtectedAdminRoute from "@/components/ProtectedAdminRoute";
import AppLayout from "@/components/AppLayout";
import AdminLayout from "@/components/AdminLayout";
import Landing from "@/pages/Landing";
import LogoOptions from "@/pages/LogoOptions";
import AccountOptions from "@/pages/AccountOptions";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import Dashboard from "@/pages/Dashboard";
import ContactsPage from "@/pages/ContactsPage";
import RecoveryPage from "@/pages/RecoveryPage";
import WhatsAppPage from "@/pages/WhatsAppPage";
import Integrations from "@/pages/Integrations";
import Transactions from "@/pages/Transactions";
import Simulator from "@/pages/Simulator";
import SettingsPage from "@/pages/SettingsPage";
import ChatPage from "@/pages/ChatPage";
import ConnectionPage from "@/pages/ConnectionPage";
import LogsPage from "@/pages/LogsPage";
import PlanCheckoutPage from "@/pages/PlanCheckoutPage";
import WelcomeModal from "@/components/WelcomeModal";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminClients from "@/pages/admin/AdminClients";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminTenants from "@/pages/admin/AdminTenants";
import AdminSubscriptions from "@/pages/admin/AdminSubscriptions";
import AdminPlans from "@/pages/admin/AdminPlans";
import AdminAdmins from "@/pages/admin/AdminAdmins";
import AdminIntegrations from "@/pages/admin/AdminIntegrations";
import AdminWhatsApps from "@/pages/admin/AdminWhatsApps";
import AdminLogs from "@/pages/admin/AdminLogs";
import AdminSupport from "@/pages/admin/AdminSupport";
import AdminAnalytics from "@/pages/admin/AdminAnalytics";
import { Toaster } from "sonner";

export default function App() {
  return (
    <div className="App dark">
      <AdminAuthProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              {/* Public routes */}
              <Route path="/" element={<Landing />} />
              <Route path="/logos" element={<LogoOptions />} />
              <Route path="/account-options" element={<AccountOptions />} />
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />

              {/* Admin routes */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route
                path="/admin"
                element={
                  <ProtectedAdminRoute>
                    <AdminLayout />
                  </ProtectedAdminRoute>
                }
              >
                <Route index element={<Navigate to="/admin/dashboard" replace />} />
                <Route path="dashboard" element={<AdminDashboard />} />
                <Route path="clients" element={<AdminClients />} />
                <Route path="clients/:id" element={<AdminUsers />} />
                <Route path="subscriptions" element={<AdminSubscriptions />} />
                <Route path="users" element={<AdminUsers />} />
                <Route path="tenants" element={<AdminTenants />} />
                <Route path="plans" element={<AdminPlans />} />
                <Route path="admins" element={<AdminAdmins />} />
                <Route path="integrations" element={<AdminIntegrations />} />
                <Route path="whatsapps" element={<AdminWhatsApps />} />
                <Route path="logs" element={<AdminLogs />} />
                <Route path="support" element={<AdminSupport />} />
                <Route path="analytics" element={<AdminAnalytics />} />
              </Route>

              {/* User app routes */}
              <Route
                path="/app"
                element={
                  <ProtectedRoute>
                    <AppLayout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<Navigate to="/app/dashboard" replace />} />
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="chat" element={<ChatPage />} />
                <Route path="contacts" element={<ContactsPage />} />
                <Route path="recovery" element={<RecoveryPage />} />
                <Route path="connection" element={<ConnectionPage />} />
                <Route path="whatsapp" element={<WhatsAppPage />} />
                <Route path="integrations" element={<Integrations />} />
                <Route path="tracking" element={<Navigate to="/app/dashboard" replace />} />
                <Route path="sequences" element={<Navigate to="/app/dashboard" replace />} />
                <Route path="automation/*" element={<Navigate to="/app/dashboard" replace />} />
                <Route path="transactions" element={<Transactions />} />
                <Route path="logs" element={<LogsPage />} />
                <Route path="monitoring" element={<Navigate to="/app/dashboard" replace />} />
                <Route path="dev-center" element={<Navigate to="/app/dashboard" replace />} />
                <Route path="simulator" element={<Simulator />} />
                <Route path="settings" element={<SettingsPage />} />
                <Route path="plan-checkout" element={<PlanCheckoutPage />} />
              </Route>

              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
          <Toaster
            theme="dark"
            position="top-right"
            toastOptions={{
              style: {
                background: "#111827",
                border: "1px solid rgba(255,255,255,0.08)",
                color: "#f1f5f9",
                fontFamily: "Manrope, ui-sans-serif, system-ui, sans-serif",
              },
            }}
          />
        </AuthProvider>
      </AdminAuthProvider>
    </div>
  );
}
